import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";



const getAllCity = createAsyncThunk('getAllCity', async ({cityname , state  , country}, { rejectWithValue }) => {
    try {
        // console.log(cityname , state , country)
        const payload = {cityname  , state , country }
        const response = await axiosInstance.post('/citydetail/getcitydetail' ,payload );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
})


const getCompanySlice = createSlice({
    name: 'citydetail',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCity.pending, (state) => {
                state.loading = true;
                state.isError = false;
                state.isSuccess = false;
                state.data = null;
                state.error = null;
            })
            .addCase(getAllCity.rejected, (state, action) => {
                state.loading = true;
                state.isError = true;
                state.isSuccess = false;
                state.data = null;
                state.error = action.payload || action.error.message;
            })
            .addCase(getAllCity.fulfilled, (state, action) => {
                state.loading = false;
                state.isError = false;
                state.isSuccess = true;
                state.data = action.payload;

            })
    }
})



export { getAllCity };
export default getCompanySlice.reducer;
